/**
 * UnsubscribePage (§166) — public, full-screen confirmation reached from the one-click
 * unsubscribe link in a farm's marketing email. Posts {tenant_id, token} to the public
 * endpoint (no auth) which flips the customer's marketing opt-ins off, then shows a
 * confirmation. Pre-auth page, so brand amber (theme isn't loaded before sign-in).
 */
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { customersApi } from '../lib/api'

export default function UnsubscribePage() {
  const { tid, token } = useParams<{ tid: string; token: string }>()
  const [state, setState] = useState<'working' | 'done' | 'error'>('working')

  useEffect(() => {
    if (!tid || !token) { setState('error'); return }
    customersApi.unsubscribe(tid, token).then(() => setState('done')).catch(() => setState('error'))
  }, [tid, token])

  return (
    <div style={{ minHeight: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, background: '#0E1209', color: '#F4F1E8' }}>
      <div style={{ maxWidth: 440, textAlign: 'center', background: '#161C12', border: '1px solid #2A341F', borderRadius: 16, padding: '36px 28px' }}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>🥭</div>
        {state === 'working' && <p style={{ fontSize: 15, color: '#B9C3A8' }}>Updating your preferences…</p>}
        {state === 'done' && (
          <>
            <h1 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>You're unsubscribed</h1>
            <p style={{ fontSize: 14, color: '#B9C3A8', lineHeight: 1.5 }}>
              You won't receive any more marketing emails from this farm. You may still get
              order or account messages if you have an active order.
            </p>
          </>
        )}
        {state === 'error' && (
          <>
            <h1 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>Link not valid</h1>
            <p style={{ fontSize: 14, color: '#B9C3A8', lineHeight: 1.5 }}>
              This unsubscribe link is invalid or has expired. If you keep receiving emails,
              reply to one and ask to be removed.
            </p>
          </>
        )}
      </div>
    </div>
  )
}
